// extracted by mini-css-extract-plugin
export default {"input":"tap_filter_type_selector_input__vtUlj","options":"tap_filter_type_selector_options__uITTZ"};